RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const PostRegistration = apps.PostRegistration = window.createMarionetteApp();
    PostRegistration.name = 'postRegistration';

    PostRegistration.addRegions({
        mainRegion: '.x-main-region'
    });
});
